import React from "react";
import { Header, Title, Box, Menu, Anchor, Image } from "grommet";
import micosmoIcon from "../img/micosmo-icon.png";
import HomeIcon from "grommet/components/icons/base/Home";

const PageHeader = (props) => (
  <Header colorIndex="grey-2" justify="center">
    <Box
      flex={true}
      justify="start"
      pad={{ horizontal: "medium" }}
      direction="row"
      responsive={false}
    >
      <Title>
        <img src={micosmoIcon} style={{ width: "150px" }} />
      </Title>
      <Box pad="small" flex="grow" />
      <Menu
        label={props.page}
        inline={true}
        direction="row"
        justify="end"
        align="center"
      >
        <Anchor href="#" label="home" />
        {/* <Anchor href="#/resume" label="resume" /> */}
        <Anchor href="#/projects" label="projects" />
      </Menu>
      <Box pad="small" />
    </Box>
  </Header>
);

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/header.js